<template>
  <div class="not-found">
    <p>page not found</p>
  </div>
</template>
